import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Avatar, AvatarGroup, Body2, Dot } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import { getUsersByIds } from "~/store/selectors/selector.users";
import { replaceAvatarSize } from "~/utils/utils";
import ProjectName from "../../project/ProjectName";

export const CalendarReminderItem = ({ subscribers, parent }) => {
  const showTaskNumber = useSelector((state) => getConfigOption(state, `show_task_id`));
  const navigate = useNavigate();
  const users = useSelector((state) => getUsersByIds(state, subscribers));
  const handleLink = useCallback(() => {
    navigate(`?modal=${parent.class}-${parent.id}-${parent.project_id}`);
  }, [navigate, parent]);

  return (
    <div
      className="tw-max-w-full tw-w-full tw-cursor-pointer tw-flex tw-h-10 tw-items-center tw-border-b tw-border-solid tw-border-0 tw-border-[var(--color-theme-300)] tw-justify-between task-list-item hover:tw-opacity-100"
      data-testid="calendar-item"
      onClick={handleLink}
    >
      <div className="tw-flex-1 tw-truncate tw-flex tw-items-center">
        <Body2
          weight="medium"
          className={classNames("tw-truncate tw-max-w-[340px] tw-ml-1", {
            "tw-text-red-alert": parent?.is_important,
          })}
        >
          {showTaskNumber && parent.class === "Task" ? `#${parent?.task_number}: ${parent?.name}` : `${parent?.name}`}
        </Body2>

        <div className="tw-px-[6px] tw-flex tw-justify-center tw-items-center">
          <Dot
            color="#89898E"
            size={4}
          />
        </div>
        <Body2
          color="tertiary"
          weight="medium"
          className="tw-truncate tw-max-w-[340px]"
        >
          <ProjectName id={parent?.project_id} />
        </Body2>
      </div>
      <AvatarGroup
        limit={5}
        size={24}
        className="hover:tw-bg-transparent hover:tw-cursor-pointer tw-cursor-default tw-mr-1"
        hasTooltip
      >
        {Object.values(users.toJS()).map((i, index) => {
          return (
            <Avatar
              id={i.id}
              key={index}
              url={replaceAvatarSize(i.avatar_url, 24)}
              alt={`${i.display_name}`}
            />
          );
        })}
      </AvatarGroup>
    </div>
  );
};

CalendarReminderItem.propTypes = {
  subscribers: PropTypes.arrayOf(PropTypes.number),
  parent: PropTypes.object,
};
